import React, { Component } from 'react';
import ModalDialog from './ModalDialog';

export class UserApprovalsTable extends Component {
    apiUrl = process.env.REACT_APP_API_URL || "https://fn.chpp.carle.org/api";

    constructor(props) {
        super(props);
        this.state = {
            userApprovals: [],
            loading: true,
            error: false,
            errorMessage: "",
            isModalVisible: false,
            currentModalData: { id: 0 }
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.getDataForDialog = this.getDataForDialog.bind(this);
        this.getTableData = this.getTableData.bind(this);
        this.approve = this.approve.bind(this);
        this.deny = this.deny.bind(this);
    }

    componentDidMount() {
        this.getTableData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filterStatus !== this.props.filterStatus) {
            this.getTableData();
        }
    }

    showModal = () => {
        this.setState({ isModalVisible: true });
    };

    hideModal = () => {
        this.setState({ isModalVisible: false });
    };

    getTableData() {
        fetch(this.apiUrl + '/GetUserRegistrations?status=' + this.props.filterStatus)
            .then(response => response.json())
            .then(
                (result) => {
                    this.setState({
                        loading: false,
                        error: false,
                        errorMessage: "",
                        userApprovals: result
                    });
                },
                (error) => {
                    console.log(error);
                    this.setState({
                        loading: false,
                        error: true,
                        errorMessage: error,
                        userApprovals: null
                    });
                }
            );
    }

    getDataForDialog(approvalId) {
        fetch(this.apiUrl + '/GetRegistrationById?id=' + approvalId)
            .then(response => response.json())
            .then(
                (result) => {
                    this.setState({ currentModalData: result });
                    this.showModal();
                },
                (error) => {
                    console.log(error);
                    this.setState({
                        loading: false,
                        error: true,
                        errorMessage: error,
                        userApprovals: null
                    });
                }
            );
    }

    setApprovalStatus(status) {
        fetch(this.apiUrl + '/UpdateUserRegistrationStatus',
            {
                method: "PUT",
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({
                    ApprovalRequestId: this.state.currentModalData.id,
                    Status: status
                })
            })
            .then(
                (result) => {
                    this.getTableData(this.state.currentFilterStatus);
                    this.hideModal();
                },
                (error) => {
                    console.log(error);
                    this.setState({
                        loading: false,
                        error: true,
                        errorMessage: error,
                        userApprovals: null
                    });
                }
            );
    }

    approve() {
        this.setApprovalStatus(1);
    }

    deny() {
        this.setApprovalStatus(2);
    }

    renderUserApprovalsTable() {
        return (
            <>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Practice Name</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.userApprovals.map(userApproval =>
                            <tr key={userApproval.id}>
                                <td><button className="button-hyperlink" onClick={(e) => { e.preventDefault(); this.getDataForDialog(userApproval.id); }}>{userApproval.firstName + ' ' + userApproval.lastName}</button></td>
                                <td>{userApproval.email}</td>
                                <td>{userApproval.practiceName}</td>
                                <td>{userApproval.status}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <ModalDialog show={this.state.isModalVisible} handleClose={this.hideModal} modalData={this.state.currentModalData} handleApprove={this.approve} handleDeny={this.deny} />
            </>
        );
    }

    render() {
        let contents = this.state.error
            ? <p>Error:  <span dangerouslySetInnerHTML={{ __html: this.state.errorMessage }}></span></p>
            : this.state.loading
                ? <p><em>Loading...</em></p>
                : this.renderUserApprovalsTable();

        return (
            <div>
                {contents}
            </div>
        );
    }
}